<script lang="ts">
  import { onMount, onDestroy } from 'svelte';
  import { currentVideoId, isPlaying, platform, twitchId, updateMiniPlayer, isMiniPlayerActive } from '$lib/stores/miniPlayerStore';
  import { page } from '$app/stores';
  import { writable } from 'svelte/store';
  import { goto } from '$app/navigation';
	import { el } from 'date-fns/locale';

  let platformValue: string | null = null;
  let isMobile: boolean = false; // モバイル判定用の変数
  let videoHeight: number = 0; // 動的に設定する高さ
  let videoWidth: number = 0; // 動的に設定する幅
  let isVideoPage: boolean = false; // 動画ページかどうかのフラグ
  let embedDomain = '';
  const isVisible = writable(true); // 表示状態を管理

  // ストアから状態を購読
  $: $currentVideoId, $isPlaying, $platform, $twitchId, $isMiniPlayerActive;

  // コンポーネントがマウントされたときにストアの値を取得
  onMount(() => {
    embedDomain = window.location.hostname;
    platformValue = $platform;

    // ページのパスを監視して動画ページかどうかを判定
    const unsubscribe = page.subscribe(($page) => {
      isVideoPage = $page.url.pathname.startsWith('/video/');
    });

    return () => {
      unsubscribe(); // クリーンアップ
    };
  });

  function closeMiniPlayer() {
        isVisible.set(false);
        setTimeout(() => {
            updateMiniPlayer(null, false); // ストアをリセット
        }, 300); // アニメーションの時間に合わせて遅延
    }

  // コンポーネントが破棄されるときにストアの値をリセット
  onDestroy(() => {
    updateMiniPlayer(null, false);
  });

  // レイアウトのマウント時にデバイスの幅を確認
  onMount(() => {
    console.log($platform);
    isMobile = window.innerWidth < 1024; // lg breakpointを基準にする
    videoWidth = isMobile ? window.innerWidth : window.innerWidth; // モバイルの場合の幅
    videoHeight = (videoWidth * 9) / 16; // 16:9のアスペクト比に基づいて高さを計算
    console.log($twitchId)
  });

  function goToVideoPage() {
        if ($currentVideoId) {
            goto(`/video/${$currentVideoId}`); // 動画ページに遷移
        }
  }
</script>

{#if $isMiniPlayerActive}
    <div class="mini-player {isVideoPage ? '' : 'compact-ui'} {isVideoPage ? 'top-0' : 'bottom-0'} bg-gray-800 text-white shadow-lg z-50">
      {#if !isVideoPage}
      <div class="icon-container">
        <button class="icon-button" on:click={closeMiniPlayer}>
            <div class="close-icon">
                &times; <!-- 閉じるアイコン -->
            </div>
        </button>
        <div class="divider"></div>
        <button class="icon-button" on:click={goToVideoPage}>
            <div class="video-link-icon">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" />
                    <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" />
                </svg>
            </div>
        </button>
    </div>
  {/if} <!-- ここで閉じる -->
  
  {#if $platform === 'youtube'}
      <iframe
          width="100%"
          height={isVideoPage ? videoHeight : '100'}
          src="https://www.youtube.com/embed/{$currentVideoId}?autoplay=1&controls=1"
          frameborder="0"
          allow="autoplay; encrypted-media"
          allowfullscreen
      ></iframe>
  {:else if $platform === 'twitch'}
      <!-- <iframe
      src="https://player.twitch.tv/?video=v{$currentVideoId}&parent={embedDomain}&autoplay=false"
      frameborder="0"
      allowfullscreen
      scrolling="no"
      height="720"
      width="1280"      
      class="w-full h-full"
      style="height: {videoHeight}px;"
    ></iframe> -->
    <iframe
      src="https://player.twitch.tv/?channel={$twitchId}&muted=false&parent=vt-grid.com"
      frameborder="0"
      allowfullscreen
      scrolling="no"
      height={isVideoPage ? videoHeight : '100'}
      class="w-full h-full"
      style="height: {isVideoPage ? videoHeight : '100'}px;"
      ></iframe>
  {/if} <!-- ここで閉じる -->

</div> <!-- ここで閉じる -->
{/if} <!-- ここで閉じる -->

<style>
.divider {
        width: 1px; /* 境界線の幅 */
        height: 30px; /* 境界線の高さ */
        background-color: rgba(255, 255, 255, 0.5); /* 境界線の色 */
        margin: 0 10px; /* 境界線の左右のマージン */
    }

 .compact-ui-overlay {
        position: absolute; /* 絶対位置 */
        top: 0; /* 上に固定 */
        right: 0; /* 右に固定 */
        left: 0; /* 左に固定 */
        bottom: 0; /* 下に固定 */
        display: flex; /* フレックスボックスを使用 */
        justify-content: center; /* 右揃え */
        align-items: flex-start; /* 上揃え */
        padding: 10px; /* パディングを追加 */
        z-index: 1; /* 他の要素の上に表示 */
    }

    .icon-container {
        display: flex; /* フレックスボックスを使用 */
        align-items: center; /* 中央揃え */
        width: 100%; /* 幅を100%に設定 */
        justify-content: center;
    }

    .icon-button {
        background: none; /* 背景なし */
        border: none; /* ボーダーなし */
        cursor: pointer; /* カーソルをポインターに */
        color: white; /* アイコンの色 */
        padding: 10; /* パディングを追加してタップしやすく */
        flex: 1; /* 各ボタンが均等に幅を取る */
        text-align: center; /* テキストを中央揃え */
    }

    .divider {
        width: 1px; /* 境界線の幅 */
        height: 30px; /* 境界線の高さ */
        background-color: rgba(255, 255, 255, 0.5); /* 境界線の色 */
        margin: 0 10px; /* 境界線の左右のマージン */
    }

    .close-icon {
        font-size: 20px; /* フォントサイズ */
    }

    .video-link-icon {
        font-size: 20px; /* フォントサイズ */
        text-align: -webkit-center;
        padding-right: 3px;
    }

  .mini-player {
    width: 100%; /* 幅を100%に設定 */
    position: fixed; /* 動画ページでは固定位置 */
    right: 0; /* 右側に固定 */
    background: rgb(0, 0, 0); /* 半透明の背景色 */
    border-top-left-radius: 10px; /* 角を丸くする */
    border-top-right-radius: 10px; /* 角を丸くする */
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.5); /* 上部にシャドウを追加 */
  }

  .compact-ui {
    position: fixed; /* 常に右下に固定 */
        bottom: 10px; /* 下からの距離 */
        right: 10px; /* 右からの距離 */
        width: 180px; /* 幅を320pxに設定 */
        height: auto; /* 高さは自動 */
        background: rgba(34, 34, 34, 0.9); /* 半透明の背景色 */
        border-radius: 10px; /* 角を丸くする */
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.5); /* シャドウを追加 */
        display: flex; /* フレックスボックスを使用 */
        flex-direction: column; /* 縦に並べる */
        align-items: center; /* 中央揃え */
    }
  .controls {
    display: flex;
    justify-content: center;
    margin-top: 5px;
  }

  .compact-ui-overlay {
    width: 100%;
    height: 25px;
  }

  .play-button {
        background-color: #1db954; /* Spotifyの緑色 */
        color: white;
        border: none;
        border-radius: 5px;
        padding: 5px 10px;
        cursor: pointer;
        transition: background-color 0.3s;
    }

    .play-button:hover {
        background-color: #1aa34a; /* ホバー時の色 */
    }

</style>